import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { VerificationMethodModel } from 'app/model/otp/otp.model';

@Component({
  selector: 'act-verify-method',
  templateUrl: './verify-method.component.html',
  styleUrls: ['./verify-method.component.scss']
})
export class VerifyMethodComponent implements OnInit {

  @Input() isLoading = false;
  @Input() methods: VerificationMethodModel[];
  @Output() selectMethod: EventEmitter<VerificationMethodModel> = new EventEmitter();

  public selectedMethod: VerificationMethodModel;

  public elementId = 'verify-otp-methods';

  constructor() { }

  ngOnInit() {
  }

  onSelectMethod(method: string) {
    this.selectedMethod = this.methods.find(o => o.method === method);
    this.selectMethod.emit(this.selectedMethod);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/verify-otp/verify-method/verify-method.component.ts